import { createSelector } from "reselect";

const getNFOappliedFilterList = (state: any) => state.getIn(['nfoReducer', 'nfoAppliedFilterList']);
const getNFOappliedSortOption = (state: any) => state.getIn(['nfoReducer', 'nfoAppliedSortItem']);

const NFOSelector = createSelector(
    [getNFOappliedFilterList,getNFOappliedSortOption], 
    (
        nfoAppliedFilterList,nfoAppliedSortItem
    ) => ({
        nfoAppliedFilterList,nfoAppliedSortItem
    })
);
export default NFOSelector;